<template>
    <div
        :class="[
            'md-house',
            'grid-v3',
            'grid',
            'template4',
            morePosition === 'top' ? 'top-more' : ''
        ]"
        v-if="result && result.listings && result.listings.length > 0"
        :style="{ paddingTop, marginBottom }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div class="house-title" :class="title ? '' : 'no-title'">
                <div class="main-title">
                    <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                    <a
                        v-if="moreText && !isMobileSize"
                        class="mg-more"
                        :href="moreLink"
                        :aria-label="moreLinkPurpose"
                        :style="moreStyle"
                        rel="noopener noreferrer"
                    >
                        {{ moreText }}
                        <i class="iconfont icon-next"></i>
                    </a>
                </div>
                <div v-if="desc" class="desc" v-html="desc"></div>
            </div>
            <Grid
                :class="{ 'full-screen': fullColumn }"
            />
            <a
                v-if="moreText && isMobileSize"
                class="mg-more"
                :href="moreLink"
                :aria-label="moreLinkPurpose"
                :style="moreStyle"
                rel="noopener noreferrer"
            >
                {{ moreText }}
                <i class="iconfont icon-next"></i>
            </a>
            <MlsDesclaimer v-if="wordPressSSR" theme="fashion" />
        </module-box>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>

    <div v-else-if="waiting" class="waiting"></div>
</template>

<script>
import Core from '../index';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    mixins: [Core],
    components: { 
        Grid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v3_grid"*/ './grid.vue'
            )),
    }
};
</script>
